import { render } from "./SimplePollCreationStepper.vue?vue&type=template&id=13ce8000&scoped=true"
import script from "./SimplePollCreationStepper.vue?vue&type=script&lang=js"
export * from "./SimplePollCreationStepper.vue?vue&type=script&lang=js"

import "./SimplePollCreationStepper.vue?vue&type=style&index=0&id=13ce8000&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ce8000"]])

export default __exports__